import React, { useState } from 'react';

const CustomerNote = ({ setShowNotePopup, applyNote }) => {
  const [note, setNote] = useState("");

  const handleApply = () => {
    applyNote(note);
    setShowNotePopup(false);
  };

  const handleDiscard = () => {
    setShowNotePopup(false);
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        <h3>Add Internal Note</h3>
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter note"
        />
        <div className="popup-buttons">
          <button onClick={handleApply}>Apply</button>
          <button onClick={handleDiscard}>Discard</button>
        </div>
      </div>
    </div>
  );
};

export default CustomerNote;
